import * as React from 'react';

import AlertsEntityTable from 'security-app/components/SecurityEvents/Alerts/AlertsEntityTable';
import { Row, Col } from 'components/bootstrap';

function GeneralUI() {
  return (
    <Row className="content">
      <Col md={12}>
        <AlertsEntityTable />
      </Col>
    </Row>
  );
}

export default GeneralUI;
